import React, {Component} from 'react';
import moment from 'moment/min/moment-with-locales.min';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import {drupalFormatWithoutTime} from '../../../../config';
import {
  orderLengthAction,
  ticketObjectAction
} from './calendar-actions';
import {connect} from 'react-redux';
import { ShoppingCart32 } from '@carbon/icons-react';
import findDayEntity, {secondsToHoursAndMinutes} from '../../../../calendar/calendar-context.js';

const mapStateToProps = state => ({
  ticketObject: state.calenderStore.ticketObject,
});

class TicketForm extends Component {

  constructor(props) {
    super(props);

    const unikatumCalendar = window.unikatum_calendar;

    // Check if chosen day is weekend
    const weekend = this.checkIfWeekend(props.selectedDay);

    // Closed days.
    const closedDays = [];
    unikatumCalendar.days.closed.entities.forEach(day => {
      closedDays.push(day.fieldDatumTag.value);
    })

    this.state = {
      showModal: false,
      cart: [],
      time: "0",
      ticket: weekend ?  window.tickets.entities.find(el => el.fieldArt == "1") : window.tickets.entities.find(el => el.fieldArt == "0"),
      closedDays: closedDays,
      selectedDayObject: findDayEntity(props.selectedDay)
    }
  }

  renderTimeSlotOptions = () => {
    return (
      <>
        <option value="0" disabled>{this.props.t('Zeit auswählen')}</option>
        {
          this.state.selectedDayObject?.fieldDayTypeEntity?.fieldTimeslots &&
          this.state.selectedDayObject.fieldDayTypeEntity.fieldTimeslots.map(slot => {
            return <option key={this.timeslotString(slot.from, slot.to)}
                           data-slot-from={slot.from}
                           data-slot-to={slot.to}
                           value={this.timeslotString(slot.from, slot.to)}
                           disabled={this.checkOptionDisabled(slot.from, slot.to)}>{this.timeslotString(slot.from, slot.to)}</option>;
          })
        }
      </>
    );
  }

  timeslotString(from, to) {
    return secondsToHoursAndMinutes(from) + ' - ' + secondsToHoursAndMinutes(to);
  }

  checkOptionDisabled(from, to) {
    const date = new Date();
    const dateSeconds = moment(date, 'HH:mm:ss: A').diff(moment().startOf('day'), 'seconds');
    if ((moment(date).format('dddd, DD.MM.YYYY')) == (moment(this.props.selectedDay).format('dddd, DD.MM.YYYY'))) {
      if ((dateSeconds >= from && dateSeconds >= to)) {
        return true;
      }
    }
    return false;
  }

  checkIfWeekend = day => {
    return new Date(day).getDay() % 6 === 0;
  }

  getTimeslots = () => {

    moment.locale(this.props.i18n.language);

    // let FormData = {
    //   field_datum: moment(this.props.selectedDay).format('YYYY-MM-DD')
    // }

    axios({
      method: "get",
      // url: "/content_helper/add/" + moment(this.props.selectedDay).format('YYYY-MM-DD') + "?_format=json",
      url: "/content-helper/get-timeslots/" + moment(this.props.selectedDay).format('YYYY-MM-DD'),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.personalToken
      },
      data: JSON.stringify([FormData])
    })
      .then((response) => {
        // handle success
        if (this.isObjectEmpty(response.data) == false) {
          this.updateCartTimeslots(response.data);
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })

  }

  showAddToCart = () => {
    this.setState({
      showModal: true
    }, () => {
      setTimeout(() => {
        this.setState({
          showModal: false
        }, () => {
          this.props.dispatch(ticketObjectAction({
            date: "",
            time: ""
          }))
        })
      }, 10000)
    })
  }

  updateCart = () => {
    axios({
      method: 'get',
      url: '/cart?_format=json',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.personalToken
      }
    })
      .then((response) => {
        // handle success
        this.setState({
          cart: response.data
        }, () => this.props.dispatch(orderLengthAction(this.state.cart)))
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  }

  updateCartTimeslots = (ticketTimeslots) => {
    this.state.selectedDayObject.fieldDayTypeEntity.fieldTimeslots.map(slot => {
      ticketTimeslots.map(timeslot => {
        if ((timeslot.from >= slot.from && timeslot.to <= slot.to) && timeslot.ticket_sold >= timeslot.ticket_limit) {
          let nodeList = document.querySelectorAll('[data-slot-from="' + slot.from + '"]');
          for (let i = 0; i < nodeList.length; i++) {
            nodeList[i].disabled = true;
          }
        }
      })
    })
  }

  submitToCart = () => {

    moment.locale(this.props.i18n.language);

    let FormData = {
      purchased_entity_type: "commerce_product_variation",
      purchased_entity_id: this.state.ticket.entityId,
      quantity: "1",
      field_datum: moment(this.props.selectedDay).format('DD.MM.YYYY'),
      field_uhrzeit: this.state.time,
      title: "Ticket"
    }

    axios({
      method: "post",
      url: "/cart/add?_format=json",
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.personalToken
      },
      data: JSON.stringify([FormData])
    })
      .then((response) => {
        // handle success
      })
      .then(() => {
        // Update Cart
        this.updateCart();
        this.props.dispatch(ticketObjectAction({
          date: moment(this.props.selectedDay).format('dddd, DD.MM.YYYY'),
          time: this.state.time
        }));
        this.showAddToCart();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })

  }

  timeHandler = e => {
    let value = e.target.value

    this.setState({ time: value })
  }

  isObjectEmpty = (objectName) => {
    return JSON.stringify(objectName) === "{}";
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedDay !== this.props.selectedDay) {
      // Check if chosen day is weekend
      const weekend = this.checkIfWeekend(this.props.selectedDay);

      this.setState({
        selectedDayObject: findDayEntity(this.props.selectedDay),
        time: "0",
        ticket: weekend ?  window.tickets.entities.find(el => el.fieldArt == "1") : window.tickets.entities.find(el => el.fieldArt == "0")
      })
    }
  }

  render() {
    moment.locale(this.props.i18n.language);

    if (
      this.state.closedDays.includes(this.state.selectedDayObject.fieldDatumTag.value) ||
      this.state.selectedDayObject.fieldNoOnlineTickets === true ||
      (moment(this.props.selectedDay).format(drupalFormatWithoutTime) < moment().format(drupalFormatWithoutTime))
    ) {
      return null;
    }

    this.getTimeslots();

    return (
      <div className="calendar-form text-center">
        <label className="mb-3">{moment(this.props.selectedDay).format('dddd, DD.MM.YYYY')}</label>
        <select className="form-control calendar-ticket-select-form mb-3" value={this.state.time} onChange={e => this.timeHandler(e)}>
          {this.renderTimeSlotOptions()}
        </select>
        {this.state.time !== "0" &&
          <button className="btn btn-cta btn-with-icon" onClick={this.submitToCart}>
            <ShoppingCart32/>
            <span>{this.props.t('in den Warenkorb legen')}</span>
          </button>
        }
        {this.state.showModal &&
          <>
            <div className="mt-5 mb-3">{`${this.props.t('Ticket für')} ${this.props.ticketObject.date} ${this.props.ticketObject.time} ${this.props.t('wurde in den Warenkorb gelegt')}`}</div>
            <a href="/cart" className="btn btn-cta">» {this.props.t('zum Warenkorb')}</a>
          </>
        }
      </div>
    );
  }
}

TicketForm.propTypes = {};

export default connect(mapStateToProps)(withTranslation()(TicketForm));
